import React from 'react';

import TextBox from './TextBox';

import {useMediaQuery} from '../../hooks/useMediaQuery';
import styles from './styles/about-01.module.css';

import {ReactComponent as ArrowDownImg} from '../../assets/about01/arrow-down.svg';
import {ReactComponent as MembersSmImg} from '../../assets/about01/members-sm.svg';
import {ReactComponent as MembersImg} from '../../assets/about01/members.svg';
import {ReactComponent as Text01Img} from '../../assets/about01/text01.svg';
import {ReactComponent as Text02Img} from '../../assets/about01/text02.svg';
import {ReactComponent as Text03Img} from '../../assets/about01/text03.svg';
import {ReactComponent as Text04Img} from '../../assets/about01/text04.svg';
import {ReactComponent as Text05Img} from '../../assets/about01/text05.svg';
import {ReactComponent as Text06Img} from '../../assets/about01/text06.svg';
import {ReactComponent as Text07Img} from '../../assets/about01/text07.svg';
import {ReactComponent as Text08Img} from '../../assets/about01/text08.svg';
import {ReactComponent as Text09Img} from '../../assets/about01/text09.svg';
import {ReactComponent as Text10Img} from '../../assets/about01/text10.svg';
import {ReactComponent as Text11Img} from '../../assets/about01/text11.svg';
import {ReactComponent as Text12Img} from '../../assets/about01/text12.svg';
import {ReactComponent as Text13Img} from '../../assets/about01/text13.svg';
import {ReactComponent as Text14Img} from '../../assets/about01/text14.svg';
import {ReactComponent as Text15Img} from '../../assets/about01/text15.svg';
import {ReactComponent as Text16Img} from '../../assets/about01/text16.svg';

export default function About01() {
    const mobileSmall = useMediaQuery('(max-width: 480px)');

    return (
        <div className={styles.wrapper}>
            <div className={styles.containerImg}>
                {mobileSmall 
                    ? <MembersSmImg preserveAspectRatio="none" />
                    : <MembersImg preserveAspectRatio="xMinYMin slice" />
                }
            </div>
            <div className={styles.containerText}>
                <div className={styles.boxText}>
                    <div className={styles.textList}>
                        <TextBox TextImg={Text01Img} />
                        <TextBox TextImg={Text02Img} />
                        <TextBox TextImg={Text03Img} />
                        <TextBox TextImg={Text04Img} />
                        <TextBox TextImg={Text05Img} />
                        <TextBox TextImg={Text06Img} />
                        <TextBox TextImg={Text07Img} />
                        <TextBox TextImg={Text08Img} />
                    </div>
                    <div className={styles.textList}>
                        <TextBox TextImg={Text09Img} second />
                        <TextBox TextImg={Text10Img} second />
                        <TextBox TextImg={Text11Img} second />
                        <TextBox TextImg={Text12Img} second />
                        <TextBox TextImg={Text13Img} second />
                        <TextBox TextImg={Text14Img} second />
                        <TextBox TextImg={Text15Img} second />
                        <TextBox TextImg={Text16Img} second />
                    </div>
                </div>
                <div className={styles.boxSlogan}>
                    <p>"Make it definite, makes us infinite"</p>
                    <ArrowDownImg />
                </div>
            </div>
        </div>
    );
}
